import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { socialsAPI } from '../../api/apiClient';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

export default function SocialMediaSection() {
  const { t } = useTranslation();
  const [socials, setSocials] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSocials();
  }, []);

  const fetchSocials = async () => {
    try {
      const response = await socialsAPI.index();
      if (response.success) {
        setSocials(response.data.data || response.data || []);
      } else {
        setError(t('failed_to_fetch_socials'));
      }
    } catch (err) {
      setError(t('failed_to_fetch_socials'));
      console.error('Error fetching socials:', err);
    }
  };

  const handleChange = (id, value) => {
    setSocials(prevSocials =>
      prevSocials.map(social =>
        social.id === id ? { ...social, social_url: value } : social
      )
    );
  };

  const handleBlur = async (id, social_name, value) => {
    try {
      const result = await socialsAPI.update(id, { social_url: value });
      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: t('success'),
          text: `${t('updated')} ${social_name}`,
          timer: 1500,
          showConfirmButton: false
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: t('error'),
          text: `${t('update_failed')} ${social_name}`,
        });
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: t('error'),
        text: t('failed_to_update_socials'),
      });
      console.error('Error updating socials:', err);
    }
  };

  if (!Array.isArray(socials)) {
    return (
      <div className="dashboard-wrapper">
        <div className="dashboard-header">
          <h4 className="mb-0">{t('social_media')}</h4>
        </div>
        <div className="py-4">
          <Alert variant="danger">Error: Social data is not in expected format</Alert>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-header">
        <h4 className="mb-0">{t('social_media')}</h4>
      </div>
      <div className="py-4">
        {error && <Alert variant="danger">{error}</Alert>}
        
        <Card className="social-media-card">
          <Card.Body>
            <h5 className="social-media-title">{t('social_media_links')}</h5>
            <p className="social-media-description">
              {t('social_media_description')}
            </p>
            
            <Form className="social-media-form">
              {socials.map(social => (
                <Row className="mb-3" key={social.id}>
                  <Col>
                    <Form.Label>{social.social_name}</Form.Label>
                    <Form.Control 
                      type="url" 
                      value={social.social_url || ''}
                      onChange={(e) => handleChange(social.id, e.target.value)}
                      onBlur={(e) => handleBlur(social.id, social.social_name, e.target.value)}
                      placeholder={t(`Enter ${social.social_name} URL`)}
                    />
                  </Col>
                </Row>
              ))}
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
